import React, {useEffect, useReducer, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import debounce from "lodash/debounce";

import {cartItemInterface} from "../cartItemInterface";
import {getCurrentLayout} from "../../appLayout";
import {addToCart, removeFromCart} from "../../../actions/actionFunctions";
import AllFeaturesChecker from "../../visComponents/allFeaturesChecker";
import FeatureName from "../../visComponents/featureName";

import {getFeatureIsLocked, toFixedFeatureCost} from "../../../misc/helpers";
import {searchProductRequest} from "../../../api/search-api";
import {updateCurrentQuote} from "../../../misc/quotesFunctions";
import {usePrevious} from "../../../misc/helperHooks";
import {
  checkForDeletePopup,
  removeCartItemsWithQuoteIndex
} from "./advancedQuotingFunctions";
import {SQFT_FEATURES} from "../../sqft/constants";
import {
  setWizardConflictPopupOpened, setWizardConflictSteps,
  setWizardSelectedValues
} from "../../../actions/wizardFunctions";
import {wizardAllObjectInterface, wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {
  getCorrectedWizardGroupForFeature,
  getCurrentGroups,
  getCurrentWizardNavItems
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getPriceWithIncluded} from "../../../misc/priceFunctions";
import {getRoomNameToCompare} from "../../../misc/categorySwitchingFunctions";
import {
  getVisualizerTypeFromSubscription,
  hasSubscriptionForRoom,
  switchToNewVisualizerType
} from "../../../misc/visualizerSwitchingFunctions";
import {setActiveQuoteIndex} from "../../../actions/roomsFunctions";
import store from "../../../store";
import {renderConfirmPopup} from "../../../api/api-popups";
import {ConfirmPopupTypes} from "../../visComponents/constants";


const CartItemSearch = (props) => {

  let {cartItem, isEmpty, subPart, quantity, removeFromCart, addToCart, id, quoteIndex, intl, fabricatorData,
    confirmPopupOpened, confirmPopupTag, wizardAllObject, setWizardSelectedValues, stepIndex, wizardGroup,
    wizardList, filterGroups, qtCategoryName, setActiveQuoteIndex, setWizardConflictPopupOpened,
    setWizardConflictSteps} = props;

  const fabricatorSettings = fabricatorData.settings;

  const [productText, setProductText] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  const prevConfirmPopupOpened = usePrevious(confirmPopupOpened);
  const prevConfirmPopupTag = usePrevious(confirmPopupTag);

  const updateInputText = () => {
    if (cartItem && cartItem.cartFeature) {
      let text = cartItem.cartFeature.getFeatureName ? cartItem.cartFeature.getFeatureName() : cartItem.cartFeature.partName;
      if (text === "additionalCartItem.minimumCharge") {
        text = intl.formatMessage({id: text});
      }
      setProductText(text);
    } else if (isEmpty) {
      setProductText("");
    }
  }

  useEffect(() => {
    updateInputText();
    return () => {
      window.removeEventListener('click', handleWrapperBlur);
    }
  }, [isEmpty, id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!confirmPopupOpened && prevConfirmPopupOpened) { // update on close
      updateInputText();
    }
  }, [confirmPopupOpened]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (confirmPopupTag && confirmPopupTag.allowDelete && !confirmPopupTag.navItem && prevConfirmPopupTag
      && prevConfirmPopupTag.navItem && prevConfirmPopupTag.cartItem && prevConfirmPopupTag.cartItem.id === cartItem.id) { // update on close and apply
      removeCartItemsWithQuoteIndex(quoteIndex);
      updateForNewNavItem(prevConfirmPopupTag.navItem);
    }
  }, [confirmPopupTag]); // eslint-disable-line react-hooks/exhaustive-deps

  const debounceRequest = debounce(() => {
    return searchProductRequest(subPart.part, productText, setShowLoader)
  }, 500)

  const handleInputChange = async (event) => {
    if (subPart.part.partId === "other_related_products" || cartItem.isMinimumCharge) {
      return false
    }
    setProductText(event.target.value);
    setDropdownVisible(true);
    await debounceRequest(event.target.value)
  }

  const handleInputFocus = () => {
    if (subPart.part.partId === "other_related_products" || cartItem.isMinimumCharge) {
      return false
    }
    setDropdownVisible(true);
    window.addEventListener('click', handleWrapperBlur);
  }

  const handleWrapperBlur = (event) => {
    const disallowClasses = [".aq-dropdown", ".ui-input"];
    if (event.target && !disallowClasses.some(cls => event.target.closest(cls))) {
      closeDropdown();
    }
  };

  const closeDropdown = () => {
    setDropdownVisible(false);
    window.removeEventListener('click', handleWrapperBlur);
  };

  const handleInputBlur = () => {
    // setDropdownVisible(false);
  }

  const getNamesArray = () => {
    if (dropdownVisible) {
      if (!subPart.part.allFeaturesReceived) {
        return [{loader: true}]
      }
      const layout = getCurrentLayout();
      const searchString = productText.toLowerCase();
      let navItems;
      if (wizardAllObject) {
        const {wizardItemId, wizardSelectedValues} = wizardAllObject;
        const wizardItem = wizardList.find(wizItem => wizItem.id === wizardItemId);
        if (wizardGroup && wizardGroup.mergedGroups) {
          const currentGroups = getCurrentGroups(wizardItem, stepIndex, wizardSelectedValues);
          navItems = getCurrentWizardNavItems(wizardSelectedValues, stepIndex, wizardItem, currentGroups[0])
        } else {
          navItems = getCurrentWizardNavItems(wizardSelectedValues, stepIndex, wizardItem, wizardGroup)
        }
      } else {
        navItems = layout.designNavigationItems(
          subPart,
          [],
          "",
          false,
          true,
          filterGroups,
          {forActiveQTCategory: qtCategoryName}
        );
      }
      return navItems
        .filter(navItem => {
          const name = navItem && navItem.part && navItem.part.getFeatureName && navItem.part.getFeatureName();
          return name && name.toLowerCase().includes(searchString)
            // && (
              // (!cartItem.isEmpty && (cartItem.cartFeature.dbFeature.id === navItem.part.dbFeature.id)) // current one
              // || cartItems.every(cItem => (cItem.cartFeature.dbFeature.id !== navItem.part.dbFeature.id) // already exist
              //   || (cItem.currentQuote !== activeQuoteIndex)) // already exist in other room
            // );
        })
    }
    return []
  }

  const updateForNewNavItem = async (navItem, fromConflicting = false) => {
    if (fromConflicting) {
      setWizardConflictSteps([]);
    }
    if (!cartItem.isEmpty) {
      removeFromCart(cartItem);
    }

    if (wizardAllObject) {
      const {quoteIndex, wizardItemId} = wizardAllObject;
      const wizardItem = wizardList.find(wizItem => wizItem.id === wizardItemId);
      setWizardSelectedValues({ // set once again! as we can come from conflict popup
        [stepIndex]: {
          wizardGroup,
          selectedFeature: navItem.part,
          partId: navItem.part.partId,
        }
      }, false, wizardItem, quoteIndex);
    }

    const feature = navItem.part;
    const newQuantity = quantity || (navItem.part.sqftQuantity && navItem.part.sqftQuantity[quoteIndex] ? navItem.part.sqftQuantity[quoteIndex] : null) || 1;
    const cartItemObject = {
      selectionGroup: subPart.text,
      quantity: newQuantity,
      partId: feature.partId,
      cartFeature: feature,
      currentQuote: quoteIndex
    };
    if (qtCategoryName) {
      cartItemObject.fromQtCategory = qtCategoryName;
    }
    if (wizardAllObject) {
      cartItemObject.fromWizardId = wizardAllObject.wizardItemId;
      cartItemObject.fromWizardStep = stepIndex;
      cartItemObject.fromWizardGroupId = getCorrectedWizardGroupForFeature(wizardGroup, feature).id;
    }
    await addToCart([cartItemObject]);
    closeDropdown();
    if (navItem.part.partId === "room" && fabricatorSettings.allowVisualizerSwitching) {
      const existingSubscription = hasSubscriptionForRoom(getRoomNameToCompare(navItem.part));
      if (existingSubscription) {
        const neededVisualizerType = getVisualizerTypeFromSubscription(existingSubscription);
        if (document.kvConfig.visualizerType !== neededVisualizerType) {
          await switchToNewVisualizerType(neededVisualizerType);
          setActiveQuoteIndex(quoteIndex);
        }
      }
    }
    if (fabricatorSettings.useCategorySwitching) {
      await updateCurrentQuote(quoteIndex)
    }
  }

  const handleNavItemClick = async (navItem) => {
    if (checkForDeletePopup(cartItem, navItem, quoteIndex)) {
      return false
    }
    if (wizardAllObject) {
      const {quoteIndex, wizardItemId, wizardSelectedValues} = wizardAllObject;
      const wizardItem = wizardList.find(wizItem => wizItem.id === wizardItemId);
      setWizardSelectedValues({
        [stepIndex]: {
          wizardGroup,
          selectedFeature: navItem.part,
          partId: navItem.part.partId,
        }
      }, false, wizardItem, quoteIndex);
      const {wizardConflictingSteps} = store.getState().wizardState;
      if (wizardConflictingSteps.length) {
        setWizardConflictPopupOpened(true);
        const applyFunction = updateForNewNavItem.bind(this, navItem, true);
        const declineFunction = () => {
          console.log("declineFunction run", );
          setWizardSelectedValues({
            [stepIndex]: {
              ...wizardSelectedValues[stepIndex]
            }
          }, false, wizardItem, quoteIndex);
        };

        renderConfirmPopup(ConfirmPopupTypes.ChangeWizardToPreviousStepSelection, {
          applyFunction,
          declineFunction: declineFunction.bind(this),
          stepIndexClicked: stepIndex,
        }, false);
        return false
      }
    }
    await updateForNewNavItem(navItem);
  };

  const namesArray = getNamesArray();
  const styles = {
    height: dropdownVisible ? namesArray.length * 30 : 0
  }

  const isInputDisabled = cartItem.partId === SQFT_FEATURES.slabs;

  const loader = (
    <li className="aq-list__item aq-list__item--loading">
      <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
    </li>
  )

  return (
    <div className="aq-main__input">
      <input className="ui-input ui-input--new ui-input--gray"
             disabled={isInputDisabled}
             value={productText}
             onFocus={handleInputFocus}
             onBlur={handleInputBlur}
             onChange={handleInputChange}/>
      <div className="aq-dropdown" style={styles}>
        <ul className="aq-list">
          {showLoader ? loader : getNamesArray().map((navItem, navItemIndex) => {
            if (navItem.loader) {
              return <AllFeaturesChecker subPart={subPart} key="aq-list-loader" ignored={ignored} callBack={forceUpdate}/>
            }
            const featureIsLocked = getFeatureIsLocked(navItem.part);
            const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !featureIsLocked && !fabricatorData.hidePricesFromUser;
            const price = toFixedFeatureCost(navItem.part, 1);

            return (
              <li className="aq-list__item" key={navItemIndex} onClick={() => handleNavItemClick(navItem)}>
                <FeatureName feature={navItem.part}/>
                {showPrice ? (
                  <span className="feature-text__price">
                    {getPriceWithIncluded(price, navItem.part, fabricatorData, intl.messages)}
                  </span>
                ) : null}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

CartItemSearch.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  subPart: PropTypes.object.isRequired,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  quoteIndex: PropTypes.number.isRequired,
  qtCategoryName: PropTypes.string,
  //wizard
  wizardAllObject: PropTypes.shape(wizardAllObjectInterface),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  stepIndex: PropTypes.number,
};

const mapStateToProps = (store, ownProps) => {
  const {confirmPopupOpened, confirmPopupTag} = store.userState;
  const {wizardList} = store.wizardState;
  const {filterGroups} = store.filterState;
  const {visualizersLoaded} = store.serverState;
  const {quotes} = store.quotesState;

  return {
    // cartItems: store.cartState.cartItems,
    isEmpty: ownProps.cartItem.isEmpty,
    id: ownProps.cartItem.id,
    fabricatorData: store.fabricatorState,
    confirmPopupOpened, // is needed for updating cart item search text on popup close
    confirmPopupTag,  // is needed for changing room on popup close
    // activeQuoteIndex: store.quotesState.activeQuoteIndex,
    wizardList,
    filterGroups,
    visualizersLoaded,
    quotes,
  };
};

const mapDispatchToProps = {
  removeFromCart,
  addToCart,
  setActiveQuoteIndex,
  setWizardSelectedValues,
  setWizardConflictPopupOpened,
  setWizardConflictSteps,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CartItemSearch)
)
